/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDeviceAirtag = createReactComponent("device-airtag", "IconDeviceAirtag", [
  ["path", { d: "M4 12a8 8 0 1 0 16 0a8 8 0 0 0 -16 0", key: "svg-0" }],
  ["path", { d: "M9 15v.01", key: "svg-1" }],
  ["path", { d: "M15 15a6 6 0 0 0 -6 -6", key: "svg-2" }],
  ["path", { d: "M12 15a3 3 0 0 0 -3 -3", key: "svg-3" }]
]);

export { IconDeviceAirtag as default };
//# sourceMappingURL=IconDeviceAirtag.js.map
